<template>
  <div class="app-main-content">
    <div class="main-content" style="overflow: auto;">
      <div v-show="!isPreview" style="width: fit-content">
        <div style="display: flex">
          <div v-for="block in blocks" :key="block.pagePart.pagePartName" class="section" style="width: 336px;margin-right: 5px;">
            <el-form label-width="140px" label-position="right">
              <span :class="'title' + (readonly ? ' not-click' : '')" style="width: 100%;">
                {{ block.customLabel || block.sysLabel }}
              </span>
              <el-form-item label=" ">
                <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
                <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
                <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
                <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
              </el-form-item>
              <el-form-item v-for="element in block.uiCustomElementList" :key="element.pagePartElement.elementName">
                <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
                <el-checkbox
                  v-model="element.isDisplay"
                  :disabled="readonly || !element.pagePartElement.displayCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                  class="element-column-content"
                  @change="onDisplayChange(block, element)"
                />
                <el-checkbox
                  v-model="element.isRequire"
                  :disabled="readonly || !element.pagePartElement.requireCanCustom || !element.isDisplay || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                  class="element-column-content"
                />
                <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
                <!-- 元素设置 -->
                <span v-if="readonly" class="element-column-content">
                  <div v-if="(element.languageList && element.languageList.length > 0) || element.multipleRole" class="look-blue" @click="onEditElementLabel(element)" />
                  <div v-else class="look-gray" />
                </span>
                <span v-if="!readonly" :class="'element-column-content' + (element.isDisplay ? '' : ' el-icon-edit-disabled')">
                  <i class="el-icon-edit" @click="onEditElementLabel(element)" />
                </span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 预览 -->
      <slot v-if="isPreview" name="preview" />
    </div>
    <!-- 元素设置弹窗 -->
    <element-set-dialog :visible.sync="elementSetDialog.visible" :element="elementSetDialog.element" :branch-id="branchId" :is-edit="isEdit" :can-set-alias="elementSetDialog.canSetAlias" />
  </div>
</template>

<script>
import ElementSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/ElementSetDialog'

export default {
  name: 'GridTab',
  components: { ElementSetDialog },
  props: {
    branchId: { type: Number, required: true },
    isEdit: { type: Boolean, required: true },
    blocks: { type: Array, required: true },
    addedElements: { type: Array, required: true },
    isPreview: { type: Boolean, required: true },
    previewConfig: { type: Object, default: null },
    canSetAliasFunction: { type: Function, default: null }
  },
  data() {
    return {
      elementSetDialog: {
        visible: false,
        element: {},
        canSetAlias: false
      }
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    }
  },
  watch: {
    blocks: {
      immediate: true,
      handler(newVal) {
        if (this.addedElements && this.addedElements.length > 0) {
          for (const block of newVal) {
            const currentAddedElements = this.addedElements.filter(p => p.pagePartElement.pagePartUuid === block.pagePartUuid)
            if (currentAddedElements.length === 0) {
              continue
            }
            const nameSet = new Set()
            for (const element of block.uiCustomElementList) {
              nameSet.add(element.pagePartElement.elementName)
            }
            for (const addedElement of currentAddedElements) {
              if (!nameSet.has(addedElement.pagePartElement.elementName)) {
                block.uiCustomElementList.push(addedElement)
              }
            }
            block.uiCustomElementList.sort((a, b) => a.serialNumber - b.serialNumber)
          }
        }
      }
    }
  },
  methods: {
    checkHqSetDisable(element) {
      return element.useHqSet && !!element.hqUICustomElement && !element.hqUICustomElement.isDisplay
    },
    onEditElementLabel(element) {
      this.elementSetDialog.element = element
      this.elementSetDialog.canSetAlias = true
      if (this.canSetAliasFunction) {
        this.elementSetDialog.canSetAlias = this.canSetAliasFunction(this.blocks[0].pagePart.pageType, element)
      } else {
        this.elementSetDialog.canSetAlias = true
      }
      this.elementSetDialog.visible = true
    },
    onDisplayChange(block, element) {
      if (element.isDisplay) {
        if (element.pagePartElement.masterIncluded) {
          element.masterIsDisplay = true
        }
        element.slaveIdDisplay = true
        block.hide = false
      } else {
        element.masterIsDisplay = false
        element.slaveIdDisplay = false
        element.isRequire = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./base.scss";
</style>
